module.exports = __webpack_public_path__ + "landing_static/img/header-md.dcb866f3.png";